import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  Tab,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahSupervisor, getAllSupervisor, getAllClient } from "stores";
import { getAllCabang } from "stores";
import { penempatanSupervisor } from "stores";
import { editStatusSupervisor } from "stores";
import { resetPassword } from "stores";

function ListSupervisor() {
  const dispatch = useDispatch();
  const storeClient = useSelector((state) => state.clientReducer);
  const supervisor = useSelector((state) => state.supervisorReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [modalSpv, setModalSpv] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [nama, setNama] = React.useState("");
  const [nik, setNik] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listSpv, setListSpv] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClientSpv, setIdClientSpv] = React.useState("");
  const [listCabang, setListCabang] = React.useState([]);
  const [idCabang, setIdCabang] = React.useState(null);
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [idSupervisor, setIdSupervisor] = React.useState("");
  const [listDetailCabang, setListDetailCabang] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitSupervisor = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }

    tambahSupervisor({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClientSpv,
    })
      .then((response) => {
        if (response.data.status === 200) {
          const newPassword = response.data.defaultPassword;

          // STEP 1: Tutup modal form input Supervisor terlebih dahulu
          handleModalClose();
          if (typeof setModalSupervisor === "function") {
            setModalSupervisor(false); // Sesuaikan dengan nama state penutup modal SPV milikmu
          }

          // STEP 2: Beri jeda 250ms agar animasi modal Bootstrap menghilang dengan mulus
          setTimeout(() => {
            // STEP 3: Tampilkan SweetAlert besar dengan proteksi tombol konfirmasi terkunci
            Swal.fire({
              title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
              icon: "success",
              width: "700px", // Memperbesar ukuran pop-up agar mencolok
              confirmButtonColor: "#1D3557",
              confirmButtonText: "Saya Sudah Menyalin & Selesai",
              allowOutsideClick: false, // Mencegah admin tidak sengaja klik area luar modal
              html: `
              <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
                <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
                  Akun Supervisor berhasil dibuat! Kredensial ini <span style="color: #dc2626; font-weight: 800;">HANYA MUNCUL SEKALI</span>. 
                  Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
                </p>
                
                <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                  <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
                  <button 
                    id="btn-copy-pass"
                    type="button"
                    style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
                  >
                    Copy
                  </button>
                </div>
              </div>
              <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
                <i class="fas fa-lock"></i>
                <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
              </div>
            `,
              didOpen: () => {
                const confirmBtn = Swal.getConfirmButton();
                const copyBtn = document.getElementById("btn-copy-pass");
                const warningText =
                  document.getElementById("copy-warning-text");

                // Kunci tombol konfirmasi utama saat modal pertama kali terbuka
                if (confirmBtn) {
                  confirmBtn.disabled = true;
                  confirmBtn.style.opacity = "0.5";
                  confirmBtn.style.cursor = "not-allowed";
                }

                if (copyBtn) {
                  copyBtn.addEventListener("click", () => {
                    // Proses salin password ke clipboard komputer
                    navigator.clipboard.writeText(newPassword);

                    // Perbarui visual tombol copy menjadi sukses
                    copyBtn.innerText = "Copied!";
                    copyBtn.style.backgroundColor = "#10B981";

                    // Buka kunci tombol konfirmasi utama setelah berhasil disalin
                    if (confirmBtn) {
                      confirmBtn.disabled = false;
                      confirmBtn.style.opacity = "1";
                      confirmBtn.style.cursor = "pointer";
                    }

                    // Ubah indikator peringatan di bawah menjadi hijau/aman
                    if (warningText) {
                      warningText.style.color = "#10B981";
                      warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                    }
                  });
                }
              },
            }).then((result) => {
              // STEP 4: Setelah Admin selesai menyalin dan menutup Swal, baru refresh tabel list data di background
              if (result.isConfirmed || result.isDismissed) {
                getAllSupervisor(dispatch, { idClient: "" });
              }
            });
          }, 250);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message || "Terjadi kesalahan",
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error.response?.data?.message || "Terjadi kesalahan pada sistem.",
        });
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusSupervisor({
      idSupervisor: idSupervisor,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllSupervisor(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanSupervisor({
        idSupervisor: idSupervisor,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllSupervisor(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihCabang(null);
    setIdCabang(null);
    setPilihClient(null);
    setModalPenempatan(false);
    setModalSpv(false);
    setIdClientSpv("");
    setPilihClient("");
    setNik("");
    setNopeg("");
    setNama("");
  };

  React.useEffect(() => {
    let tmp =
      supervisor.listSupervisor &&
      supervisor.listSupervisor.map((val) => {
        // LOGIKA KONDISI
        const isAktif = val.status === "aktif";
        const isBelumPenempatan =
          val.penempatan.length === 1 && !val.penempatan[0].namaCabang;

        // HAK ISTIMEWA: Super admin bisa edit status kapan saja
        const canEditStatus = auth.role === "super admin" || isBelumPenempatan;

        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center">
              {/* BUTTON PENEMPATAN */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Penempatan Supervisor</Tooltip>}
              >
                <Button
                  disabled={!isAktif}
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: isAktif ? "#447DF7" : "#E2E8F0",
                    border: "none",
                    color: isAktif ? "white" : "#94A3B8",
                    cursor: isAktif ? "pointer" : "not-allowed",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    setIdSupervisor(val._id);
                    getAllCabang(dispatch, { idClient: val.idClient });
                    setModalPenempatan(!modalPenempatan);
                  }}
                >
                  <i
                    className="fas fa-map-marked-alt"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* BUTTON EDIT STATUS (Dengan Bypass Super Admin) */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Edit Status</Tooltip>}
              >
                <Button
                  disabled={!canEditStatus}
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: canEditStatus ? "#76CD26" : "#E2E8F0",
                    border: "none",
                    color: canEditStatus ? "white" : "#94A3B8",
                    cursor: canEditStatus ? "pointer" : "not-allowed",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    setIdSupervisor(val._id);
                    setModalEdit(!modalEdit);
                  }}
                >
                  <i
                    className="fas fa-user-cog"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* BUTTON RESET PASSWORD */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Reset Password</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: "#F87171",
                    border: "none",
                    color: "white",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#EF4444")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#F87171")
                  }
                  onClick={async () => {
                    const result = await Swal.fire({
                      title: "Reset Password",
                      text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#1D3557",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Ya, Reset Password!",
                    });

                    if (result.isConfirmed) {
                      try {
                        // 1. Panggil API reset password
                        const response = await resetPassword({
                          idUser: val._id,
                          role: val.role,
                        });

                        // 2. Ambil password plain text dari response backend kamu
                        const newPassword = response.data.defaultPassword;

                        // 3. Tampilkan SweetAlert Sukses berukuran besar dengan tombol konfirmasi terkunci
                        Swal.fire({
                          title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
                          icon: "success",
                          width: "700px", // Membuat ukuran pop-up lebih besar dan dominan
                          confirmButtonColor: "#1D3557",
                          confirmButtonText: "Saya Sudah Menyalin & Selesai",
                          allowOutsideClick: false, // Mencegah admin tidak sengaja klik luar modal
                          html: `
                                     <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
                                       <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
                                         Password berhasil direset! Sistem telah men-hash password baru ini demi keamanan. 
                                         <br><span style="color: #dc2626; font-weight: 800;">Kredensial ini HANYA MUNCUL SEKALI</span>. 
                                         Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
                                       </p>
                                       
                                       <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                                         <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
                                         <button 
                                           id="btn-copy-pass"
                                           type="button"
                                           style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
                                         >
                                           Copy
                                         </button>
                                       </div>
                                     </div>
                                     <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
                                       <i class="fas fa-lock"></i>
                                       <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
                                     </div>
                                   `,
                          didOpen: () => {
                            const confirmBtn = Swal.getConfirmButton();
                            const copyBtn =
                              document.getElementById("btn-copy-pass");
                            const warningText =
                              document.getElementById("copy-warning-text");

                            // Secara default, kunci tombol konfirmasi utama
                            if (confirmBtn) {
                              confirmBtn.disabled = true;
                              confirmBtn.style.opacity = "0.5";
                              confirmBtn.style.cursor = "not-allowed";
                            }

                            if (copyBtn) {
                              copyBtn.addEventListener("click", () => {
                                // Proses copy teks password ke clipboard
                                navigator.clipboard.writeText(newPassword);

                                // Modifikasi tombol copy menjadi sukses
                                copyBtn.innerText = "Copied!";
                                copyBtn.style.backgroundColor = "#10B981";

                                // Buka kunci tombol konfirmasi utama setelah berhasil di-copy
                                if (confirmBtn) {
                                  confirmBtn.disabled = false;
                                  confirmBtn.style.opacity = "1";
                                  confirmBtn.style.cursor = "pointer";
                                }

                                // Ubah teks peringatan di bawah box menjadi hijau/aman
                                if (warningText) {
                                  warningText.style.color = "#10B981";
                                  warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                                }
                              });
                            }
                          },
                        });
                      } catch (error) {
                        Swal.fire({
                          title: "Error",
                          text:
                            error.response?.data?.message ||
                            "Terjadi kesalahan pada sistem.",
                          icon: "error",
                        });
                      }
                    }
                  }}
                >
                  <i className="fas fa-key" style={{ fontSize: "15px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListSpv(tmp);
  }, [supervisor.listSupervisor]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });

    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    header: {
      style: { minHeight: "56px" },
    },
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "#E3E6F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "13px",
        color: "#4E73DF", // Warna identitas AM
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "70px", // Row lebih tinggi agar data tidak sesak
        "&:not(:last-child)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "#E3E6F0",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#5A5C69",
      },
    },
  };
  const colSupervisor = [
    {
      name: "No",
      width: "60px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "User & Karyawan",
      minWidth: "200px",
      cell: (row) => (
        <div>
          <div className="fw-bold text-dark">{row.nama}</div>
          <small className="text-muted">
            {row.nopeg} | {row.kodeUser}
          </small>
        </div>
      ),
    },
    {
      name: "BPD",
      minWidth: "150px",
      omit: auth.role !== "super admin",
      selector: (row) => row.namaClient[0],
    },
    {
      name: "Cabang Penempatan",
      minWidth: "250px",
      cell: (row) => {
        // Jika tidak ada penempatan
        if (
          row.penempatan.length === 0 ||
          (row.penempatan.length === 1 && !row.penempatan[0].namaCabang)
        ) {
          return (
            <div
              className="d-flex align-items-center text-muted"
              style={{ fontStyle: "italic", fontSize: "13px" }}
            >
              <i className="fas fa-minus-circle mr-2 opacity-50"></i> Belum ada
              penempatan
            </div>
          );
        }

        // Jika ada penempatan
        return (
          <div className="py-2">
            {/* Nama Cabang Utama */}
            <div className="d-flex align-items-center mb-1">
              <i
                className="fas fa-map-marker-alt text-danger mr-2"
                style={{ fontSize: "12px" }}
              ></i>
              <span
                style={{
                  fontWeight: "700",
                  color: "#2D3748",
                  fontSize: "14px",
                }}
              >
                {row.penempatan[0].namaCabang}
              </span>
            </div>

            {/* Indikator Cabang Lainnya (Tanpa Blok Warna) */}
            {row.penempatan.length > 1 && (
              <div
                className="d-flex align-items-center mt-1"
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#4E73DF",
                  paddingLeft: "20px", // Agar sejajar di bawah teks nama cabang
                }}
                onClick={() => {
                  setListDetailCabang(row);
                  setModalDetail(true);
                }}
              >
                <span
                  style={{
                    borderBottom: "1px dashed #4E73DF",
                    fontWeight: "600",
                  }}
                >
                  <i
                    className="fas fa-external-link-alt mr-1"
                    style={{ fontSize: "10px" }}
                  ></i>
                  Lihat {row.penempatan.length - 1} cabang lainnya
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => row.action, // Pastikan row.action merender button aksi Anda
    },
  ];
  // const colSupervisor = [
  //   {
  //     name: "No",
  //     width: "80px",
  //     center: true,
  //     selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
  //   },
  //   {
  //     name: "Kode User",
  //     minWidth: "150px",
  //     center: true,
  //     selector: (row) => row.kodeUser,
  //   },
  //   {
  //     name: "No Karyawan",
  //     minWidth: "200px",
  //     center: true,
  //     selector: (row) => row.nopeg,
  //   },
  //   {
  //     name: "Nama",
  //     minWidth: "200px",
  //     center: true,
  //     selector: (row) => row.nama,
  //   },
  //   {
  //     name: "Jabatan",
  //     minWidth: "200px",
  //     center: true,
  //     selector: (row) =>
  //       row.role === "supervisor" ? "Supervisor" : "Supervisor",
  //   },
  //   {
  //     name: "BPD",
  //     minWidth: "200px",
  //     center: true,
  //     omit: auth.role === "super admin" ? false : true,
  //     selector: (row) => row.namaClient[0],
  //     // row.penempatan.length === 0 ? (
  //     //   <div style={{ fontWeight: "bold" }}>Belum Penempatan</div>
  //     // ) : (
  //     //   row.penempatan[0].namaClient
  //     // ),
  //   },
  //   {
  //     name: "Cabang",
  //     minWidth: "250px",
  //     center: true,
  //     selector: (row) =>
  //       row.penempatan.length === 1 && !row.penempatan[0].namaCabang ? (
  //         <div style={{ fontWeight: "bold" }}>Belum Penempatan</div>
  //       ) : row.penempatan.length === 1 ? (
  //         row.penempatan[0].namaCabang
  //       ) : (
  //         <>
  //           <div>{row.penempatan[0].namaCabang},...</div>
  //           <div
  //             style={{ color: "blue", cursor: "pointer" }}
  //             onClick={() => {
  //               setListDetailCabang(row);
  //               setModalDetail(true);
  //             }}
  //           >
  //             Lihat Semua
  //           </div>
  //         </>
  //       ),
  //   },
  //   {
  //     name: "Status",
  //     minWidth: "150px",
  //     center: true,
  //     // selector: (row) => (row.status === "aktif" ? "Aktif" : "Tidak Aktif"),
  //     selector: (row) => row.status,
  //     cell: (row) => {
  //       const statusStyle = getStatusUser(row.status);
  //       const tampilanLabel = row.status === "aktif" ? "Aktif" : "Tidak Aktif";

  //       return (
  //         <div
  //           style={{
  //             fontWeight: statusStyle.fontWeight,
  //             backgroundColor: statusStyle.backgroundColor,
  //             color: statusStyle.textColor,
  //             padding: "10px",
  //             borderRadius: "5px",
  //           }}
  //         >
  //           {tampilanLabel}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     name: "Aksi",
  //     minWidth: "250px",
  //     omit: auth.role === "super admin" || auth.role === "admin" ? false : true,
  //     center: true,
  //     selector: (row) => row.action,
  //   },
  // ];

  React.useEffect(() => {
    getAllSupervisor(dispatch, { idClient: "" });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      {/* <Modal
        size="lg"
        show={modalUbahPenempatan}
        onHide={() => {
          handleModalClose();
          setModalUbahPenempatan(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title as="h4" style={{ color: "black" }}>
                Form Ubah Penempatan Supervisor
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                <Form.Group>
                  <label style={{ color: "black" }}>Pilih Cabang</label>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="Pilih Cabang"
                    value={pilihCabang}
                    onChange={(value) => {
                      setPilihCabang(value);
                      setIdCabang(value.value);
                    }}
                    options={listCabang}
                    placeholder="Pilih Cabang"
                  />
                </Form.Group>
              </Form>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                // onClick={submitUbahPenempatan}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal> */}

      <Modal
        size="lg"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        scrollable
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-info-circle fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Detail Penempatan</h3>
            <p className="text-muted">Informasi wilayah Supervisor</p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <div className="mb-4 pb-3 border-bottom">
                <Row className="mb-2">
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    NAMA LENGKAP
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : {listDetailCabang.nama}
                  </Col>
                </Row>
                <Row>
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    JABATAN
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : Supervisor
                  </Col>
                </Row>
              </div>

              <div className="bg-light p-3" style={{ borderRadius: "15px" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold text-primary m-0">Daftar Cabang</h6>
                  <span
                    className="badge bg-white text-primary shadow-sm px-3 py-2"
                    style={{
                      borderRadius: "10px",
                      border: "1px solid #1D3557",
                    }}
                  >
                    Total:{" "}
                    <span className="fw-800">
                      {listDetailCabang.penempatan?.length || 0}
                    </span>
                  </span>
                </div>
                <div style={{ maxHeight: "30vh", overflowY: "auto" }}>
                  <ul className="list-group list-group-flush bg-transparent">
                    {listDetailCabang.penempatan?.map((val, index) => (
                      <li
                        key={index}
                        className="list-group-item bg-transparent border-0 py-2 ps-0 text-dark fw-600 d-flex align-items-center"
                      >
                        <div
                          className="bg-success rounded-circle mr-3 d-flex align-items-center justify-content-center"
                          style={{ width: "22px", height: "22px" }}
                        >
                          <i
                            className="fas fa-check text-white"
                            style={{ fontSize: "10px" }}
                          ></i>
                        </div>
                        {val.namaCabang}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-map-pin fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Form Penempatan</h3>
            <p className="text-muted">Tentukan cabang tugas untuk Supervisor</p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  placeholder="Cari Cabang..."
                />
              </Form.Group>
              <Button
                className="btn-block p-3 text-white"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                }}
                onClick={submitPenempatan}
              >
                SIMPAN PENEMPATAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-user-shield fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Edit Status Akun</h3>
            <p className="text-muted">
              Perbarui status aktifasi Supervisor ini
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">
                  Pilih Status Baru
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                  placeholder="Edit Status"
                />
              </Form.Group>
              <Button
                className="btn-block p-3 text-white"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                }}
                onClick={checkStatus}
              >
                UPDATE STATUS
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalSpv}
        onHide={() => {
          handleModalClose();
          setModalSpv(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-user-plus fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Tambah Supervisor</h3>
            <p className="text-muted">
              Silahkan lengkapi data profil Supervisor baru
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form>
                <Row>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">NIK</label>
                      <div className="position-relative">
                        <Form.Control
                          className="border-0 bg-light p-3"
                          style={{ borderRadius: "12px", fontWeight: "600" }}
                          onChange={handleNikChange}
                          value={nik}
                          type="text"
                          placeholder="Masukkan NIK"
                        />
                        <div
                          className="position-absolute fw-bold"
                          style={{
                            right: "15px",
                            top: "15px",
                            color: "#94a3b8",
                            fontSize: "12px",
                          }}
                        >
                          {remainingDigits} digit
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        Nama Lengkap
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNama(e.target.value)}
                        placeholder="Nama Lengkap"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        No Karyawan
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNopeg(e.target.value)}
                        placeholder="No Karyawan"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  {auth.role === "super admin" && (
                    <Col md="6" className="mb-3">
                      <Form.Group>
                        <label className="fw-bold text-dark mb-2">
                          Pilih Client
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          value={pilihClient}
                          onChange={(value) => {
                            setPilihClient(value);
                            setIdClientSpv(value.value);
                          }}
                          options={listClient}
                          placeholder="Pilih Client"
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Button
                  className="btn-block p-3 mt-4 text-white"
                  style={{
                    border: "none",
                    backgroundColor: "#1D3557",
                    borderRadius: "15px",
                    fontWeight: "800",
                    boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                  }}
                  onClick={submitSupervisor}
                >
                  SUBMIT DATA SUPERVISOR
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Tab.Content className="mt-3">
        <Card className="border-0 bg-transparent">
          {/* Container Header: Tombol Kiri, Search Kanan */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
            {/* BAGIAN KIRI: Tombol Tambah Supervisor */}
            <div className="mb-3 mb-md-0">
              {(auth.role === "super admin" || auth.role === "admin") && (
                <Button
                  onClick={() => setModalSpv(!modalSpv)}
                  className="btn-fill d-flex align-items-center shadow-sm"
                  style={{
                    backgroundColor: "#1D3557", // Navy konsisten
                    border: "none",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
                  onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                >
                  <i
                    className="nc-icon nc-simple-add mr-2"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                  <span>Tambah Supervisor</span>
                </Button>
              )}
            </div>

            {/* BAGIAN KANAN: Search Bar (Kontras Tinggi) */}
            <div style={{ width: "100%", maxWidth: "350px" }}>
              <InputGroup
                className="shadow-sm"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  border: "1px solid #ced4da",
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text
                    className="border-0"
                    style={{ backgroundColor: "#f8f9fa" }}
                  >
                    <i className="nc-icon nc-zoom-split text-dark fw-bold"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 ps-1"
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="Cari No. Karyawan / Nama..."
                  style={{
                    height: "45px",
                    backgroundColor: "#f8f9fa",
                    boxShadow: "none",
                    fontSize: "0.95rem",
                  }}
                />
              </InputGroup>
            </div>
          </div>
        </Card>
      </Tab.Content>

      {/* TABEL SUPERVISOR */}
      <Row>
        <Col md="12">
          <Card
            className="border-0 shadow-sm overflow-hidden"
            style={{ borderRadius: "15px" }}
          >
            <DataTable
              columns={colSupervisor}
              data={listSpv.filter(
                (row) =>
                  row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
                  row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
              )}
              customStyles={customStyles}
              pagination
              paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
              paginationPerPage={itemsPerPage}
              onChangePage={handlePageChange}
              highlightOnHover
              responsive
            />
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default ListSupervisor;
